import React from "react";
import { useTranslation } from "react-i18next";
import MDialog from "@/components/ui/atoms/MDialog";

export interface RemoveFromShoppingListModalProps {
  open: boolean;
  itemName: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const RemoveFromShoppingListModal: React.FC<
  RemoveFromShoppingListModalProps
> = ({ open, itemName, onClose, onConfirm, loading = false }) => {
  const { t } = useTranslation();

  return (
    <MDialog
      isOpen={open}
      onClose={onClose}
      title={t("pillbox.shoppingList.removeModalTitle")}
      description={t("pillbox.shoppingList.removeModalDescription", {
        name: itemName,
      })}
      secondaryCtaText={t("common.cancel")}
      onSecondaryCta={onClose}
      primaryCtaText={t("pillbox.shoppingList.removeModalCta")}
      onPrimaryCta={onConfirm}
      isPrimaryCtaLoading={loading}
    />
  );
};

export default RemoveFromShoppingListModal;
